(function () {
  function initLocalize() {
    document.querySelectorAll('.js-localize-wrapper').forEach(function (wrapper) {
      var trigger = wrapper.querySelector('.js-localize-trigger');
      var box = wrapper.querySelector('.js-localize-box');
      var input = wrapper.querySelector('[data-disclosure-input]');
      var form = wrapper.closest('form');
      var template = box ? box.querySelector('.js-localize-template') : null;
      if (!trigger || !box) return;

      function populate() {
        if (!template) return;
        box.appendChild(template.content.cloneNode(true));
        template.remove();
        template = null;
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        populate();
        var open = trigger.classList.toggle('js-active');
        box.classList.toggle('js-active', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      box.addEventListener('click', function (e) {
        var item = e.target.closest('.js-localize-item');
        if (!item) return;
        e.preventDefault();
        if (input) input.value = item.getAttribute('data-value') || '';
        if (form) form.submit();
      });
    });

    document.addEventListener('click', function (e) {
      document.querySelectorAll('.js-localize-wrapper').forEach(function (wrapper) {
        if (wrapper.contains(e.target)) return;
        var trigger = wrapper.querySelector('.js-localize-trigger');
        var box = wrapper.querySelector('.js-localize-box');
        if (trigger) {
          trigger.classList.remove('js-active');
          trigger.setAttribute('aria-expanded', 'false');
        }
        if (box) box.classList.remove('js-active');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLocalize);
  } else {
    initLocalize();
  }
})();
